export default [{
  path: 'atachmentspecificdocument',
  name: 'atachment-specific-document',
  component: () => import('@/app/clientarea-app/specific-document/atachmentSpecificDocument'),
  meta: {
  }
}]
